import { ErrorHandlerOptions, ReportDialogOptions } from "@sentry/angular";

export const sentryReportDialogOptions: ReportDialogOptions = {
  lang: 'en-Au',
  title: 'Oops! Something went wrong',
  subtitle: 'Our team has been notified and is working on a fix.',
  subtitle2: '',
  labelComments: 'If you have additional information, please share it with us.',
  labelSubmit: `Send report`,
  labelClose: 'Cancel',
};

export const sentryErrorHandlerOptions: ErrorHandlerOptions = {
  showDialog: true,
  dialogOptions: sentryReportDialogOptions
};
